import React from 'react'
import {
    Button,
    Container,
    Table,
    Row,
    Col,
    Label,
    Input,
} from 'reactstrap'
import '../css/QuoteViewController.css'
import { UploadFileViewController } from '../controller/UploadFileViewController'
import SimpleDropdown from '../view/DropDownView'
import { Quote } from '../model/Quote'
import { getQuote } from '../model/request/quotes'
import {
    downloadFile,
    getFiles,
    deleteFiles,
    updateFileName,
} from '../model/request/files'
import { AlertModalModel } from './modal/AlertModalController'
import {
    IoIosArrowUp,
    IoIosArrowDown,
} from 'react-icons/io';

class FilesUploaderViewController extends React.Component {

    // MARK: Override Functions

    constructor(props) {
        super(props)
        this.state = {
            'files': [],
            'did_download': [],
            'directories_created': [
                'Estimator',
                'Estimator/Quotes',
                'Project Management',
                'Project Management/Art Files',
                'Project Management/Emails',
                'Project Management/POs',
                'Project Management/Proofs',
                'Project Management/Quotes',
                'Production',
                'Shipping + Billing',
            ],
            'row_clicked': null,
            'new_directory_name': '',
            'folders_opened': [''],
        }
    }

    componentDidMount() {
        this.props.turnOnLoader()
        this.refresh()
        getQuote(this.props.id).then(
            (result) => {
                this.setState({
                    'quote': Quote.from(result.data.quote)
                })
                this.props.turnOffLoader()
            },
            (error) => {
                this.props.showError(error)
                this.props.turnOffLoader()
            }
        )
    }

    refresh() {
        this.props.turnOnLoader()
        getFiles(this.props.id).then(
            (result) => {
                this.setState({
                    'files': result.data.files,
                    'did_download': result.data.files.map(() => false),
                })
                this.props.turnOffLoader()
            },
            (error) => {
                this.props.showError(error)
                this.props.turnOffLoader()
            }
        )
    }

    updateFileName(fileId, fileName) {
        updateFileName(fileId, fileName).then(
            (result) => {},
            (error) => {
                this.props.showError(error)
            },
        )
    }

    deleteFile(index) {
        this.props.showAlertModal(
            (new AlertModalModel())
                .setTitle('Are you sure?')
                .setMessage('The file will be deleted. You can not undo this action.')
                .addYesButton((e) => {
                    const id = this.state.files[index].id

                    let first = this.state.files.slice(0, index)
                    first = first.concat(this.state.files.slice(index+1))

                    this.props.turnOnLoader()
                    deleteFiles(id).then(
                        (result) => {
                            this.setState({
                                'files': first,
                                'did_download': [
                                    ...this.state.did_download.slice(0, index),
                                    ...this.state.did_download.slice(index+1),
                                ],
                            })
                            this.props.turnOffLoader()
                        },
                        (error) => {
                            this.props.showError(error)
                            this.props.turnOffLoader()
                        }
                    )
                    this.props.closeModal()
                })
                .addNoButton((e) => {this.props.closeModal()})
        )
    }

    // MARK: Views

    renderHeader(label) {
        return <Col>
            <Label style={{
                'fontSize': '20pt',
                'fontWeight': '500',
            }}>{label}</Label>
        </Col>
    }

    renderDropDown(title, value, values, onClick) {

        let index = values.indexOf(value)
        if (index === -1 && value.length > 0) {
            values.push(value)
            index = values.length - 1
        }

        return <SimpleDropdown
            index={index}
            values={values}
            onChange={(index) => {
                if (index === values.length - 1) {
                    this.props.showTextFieldModal(title, (value) => {
                        onClick(value, index)
                    })
                } else {
                    onClick(values[index], index)
                }
            }} />
    }

    makeRows(
        files=this.state.files.map((file, index) => {
            file.index = index
            return file
        }),
        dir=[],
    ) {
        const dirName = dir.join('/')
        return <>
            {dirName === '' ? <></> :
            <tr
                style={{
                    'backgroundColor': (
                        dir.join('/') === this.state.row_clicked
                            ? 'yellow'
                            : undefined
                    ),
                }}
            ><td
                onClick={
                    (e) => {
                        if (this.state.row_clicked === null) {
                            this.setState({
                                'row_clicked': dirName,
                            })
                            return
                        }
                        this.setState((state) => {
                            if (this.state.row_clicked === null) {
                                return {
                                    row_clicked: dirName,
                                }
                            }

                            if (typeof this.state.row_clicked === 'string') {
                                const directoryIndex = state.directories_created.indexOf(
                                    this.state.row_clicked
                                )
                                let newName = null

                                if (this.state.row_clicked === dirName) {
                                    newName = [
                                        ...dir.slice(0, dir.length-2),
                                        dir[dir.length-1],
                                    ].join('/')
                                } else {
                                    newName = dirName + (dirName.length > 0 ? '/' : '') +
                                        this.state.row_clicked.substring(
                                            this.state.row_clicked.lastIndexOf('/') + 1
                                        )
                                }

                                state.directories_created[directoryIndex] = newName

                                state.files = state.files.map((file) => {
                                    if (file.name.substring(0, this.state.row_clicked.length+1) === this.state.row_clicked + '/') {
                                        file.name = newName + '/' +
                                            file.name.substring(
                                                file.name.lastIndexOf('/') + 1
                                            )
                                        this.updateFileName(file.id, file.name)
                                    }
                                    return file
                                })
                            } else {
                                state.files[state.row_clicked].name =
                                    dirName + (dir.length > 0 ? '/' : '') +
                                    state.files[state.row_clicked].name.substring(
                                        state.files[state.row_clicked].name.lastIndexOf('/') + 1
                                    )

                                this.updateFileName(
                                    state.files[state.row_clicked].id,
                                    state.files[state.row_clicked].name,
                                )
                            }

                            return {
                                'files': state.files,
                                'row_clicked': null,
                                'directories_created': state.directories_created,
                            }
                        })
                    }
                }>
                <Label
                    style={{
                        'marginLeft': ((dir.length-1) * 32) + 'px',
                    }}
                >{dir.length > 0 ? dir[dir.length-1] : ''}</Label></td>
            <td>
                <Label
                    style={{
                        'fontWeight': '400',
                        'margin': '8px',
                        'minWidth': '20px',
                        'textAlign': 'right',
                    }}
                >{files.length}</Label>
                <Button
                    onClick={() => {
                        this.setState((state) => {
                            const index = state.folders_opened.indexOf(dirName)
                            if (index === -1) {
                                state.folders_opened.push(dirName)
                            } else {
                                state.folders_opened = state.folders_opened.filter((x) => x !== dirName)
                            }
                            return {
                                'folders_opened': state.folders_opened,
                            }
                        })
                    }}
                >
                {this.state.folders_opened.indexOf(dirName) === -1 ?
                    <IoIosArrowUp
                        style={{
                            'margin-top': '-10pt',
                            'margin': '0pt',
                            'padding': '0pt',
                            'fontSize': '10pt',
                            'fontWeight': 'bold',
                            'marginTop': '-10pt',
                        }}/>
                    :
                    <IoIosArrowDown
                        style={{
                            'margin-top': '-10pt',
                            'margin': '0pt',
                            'padding': '0pt',
                            'fontSize': '10pt',
                            'fontWeight': 'bold',
                            'marginTop': '-10pt',
                        }}/>
                }
                </Button>
            </td>
            </tr>
            }
        {
            this.state.folders_opened.indexOf(dirName) === -1 ? <></> :
        [...(new Set([...files.map((x) => {
                return x.name.substring(0, x.name.indexOf('/'))
            }),
            ...this.state.directories_created.filter((x) => {
                const dirName = dir.join('/')
                return x.substring(0, dirName.length) === dirName
            }).map((x) => {
                const ending = x.substring(dir.join('/').length + (dir.length > 0 ? 1 : 0))
                const index = ending.indexOf('/')
                if (index === -1) {
                    return ending
                }
                return ending.substring(0, index)
            })
        ]))]
            .map((firstDir) => {
                if (firstDir.length > 0) {
                    const newFiles = files
                        .filter((x) => x.name.substring(0, firstDir.length) === firstDir)
                        .map((x) => {
                            return {
                                ...x,
                                'name': x.name.substring(firstDir.length + 1)
                            }
                        })

                    return this.makeRows(newFiles, [...dir, firstDir])
                } else {
                    return files
                        .filter((file) => file.name.indexOf('/') === -1)
                        .map((file) =>
                            <tr
                                style={file.index === this.state.row_clicked ?
                                    {
                                        'backgroundColor': 'yellow',
                                    }
                                    : {}
                                }
                                key={"row"+file.index}
                            >
                                <td
                                    onClick={
                                        (e) => {
                                            if (this.state.row_clicked === file.index) {
                                                this.setState((state) => {
                                                    const files = state.files
                                                    let dir = files[file.index].name
                                                    dir = dir.substring(0, dir.lastIndexOf('/'))
                                                    dir = dir.substring(0, dir.lastIndexOf('/'))
                                                    let name = files[file.index].name
                                                    name = name.substring(name.lastIndexOf('/')+1)
                                                    files[file.index].name =
                                                        dir + (dir.length > 0 ? '/' : '') + name

                                                    this.updateFileName(file.id, file.name)

                                                    return {
                                                        'files': files,
                                                        'row_clicked': null,
                                                    }
                                                })
                                            } else {
                                                this.setState({
                                                    'row_clicked': file.index,
                                                })
                                            }
                                        }
                                    }
                                ><Label
                                    style={{
                                        'marginLeft': (dir.length * 32) + 'px',
                                    }}>{file.name}</Label></td>
                                <td><Button
                                    disabled={this.state.did_download[file.index]}
                                    color="primary"
                                    onClick={(e) => {
                                        downloadFile(file.id, file.name)
                                        this.setState((state) => {
                                            state.did_download[file.index] = true
                                            return state
                                        })
                                    }}
                                    >Download</Button></td>
                                <td><Button color="danger"
                                    onClick={(e) => {
                                        this.deleteFile(file.index)
                                    }}
                                    >Delete</Button></td>
                            </tr>
                        )
                }
            })
        }</>
    }


    // MARK: View

    render() {
        return (
            <Container>
                {this.props.breadCrumbs(3, this.props.id)}
                <Row>
                    { this.state.quote ?
                        <>
                            {this.renderHeader(this.state.quote.customer_name)}
                            {this.renderHeader(this.state.quote.job_name)}
                            {this.renderHeader(this.state.quote.given_id)}
                        </>
                        : <></>
                    }
                </Row>
                <Row><Col><Container style={{'overflowX': 'auto'}}><Table>
                    <thead>
                        <tr>
                            <th className="text-center label-weight"
                                style={{'minWidth': '300px'}}>Name</th>
                            <th className="text-center label-weight"
                                style={{'minWidth': '100px'}}></th>
                            <th className="text-center label-weight"
                                style={{'minWidth': '100px'}}></th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.makeRows()}
                    </tbody>
                </Table></Container></Col></Row>
                <Row>
                    <Col>
                        <Input
                            type='text'
                            onChange={(e) => {
                                this.setState({
                                    'new_directory_name': e.target.value,
                                })
                            }}
                            value={this.state.new_directory_name}
                        />
                    </Col>
                    <Col>
                        <Button
                            color='primary'
                            onClick={(e) => {
                                this.setState((state) => {
                                    state.directories_created.push(state.new_directory_name)
                                    return {
                                        'directories_created': state.directories_created,
                                        'new_directory_name': '',
                                    }
                                })
                            }}
                        >Add Directory</Button>
                    </Col>
                </Row>
                <Row style={{'marginBottom': '20px'}}>
                    <Col>
                        <UploadFileViewController
                            quoteId={this.props.id}
                            onUploaded={() => {
                                this.refresh()
                            }}
                    /></Col>
                </Row>
            </Container>
        )
    }
}

export default FilesUploaderViewController
